import { useState } from "react";
import {
  RequestRegisterTrackingDetailRequest,
  AmazonRegisterTrackingDetailPostRequest,
  AmazonApi,
} from "../../services/OpenAPI";
import { createConfiguration } from "./common";
import { isLwaNotConnectedError } from "../../utils/lwaError";

export const useApiRegisterTrackingDetail = () => {
  const [resultRegister, setResultRegister] = useState<boolean>(false);
  const [error, setError] = useState<string | null>(null);
  const [isLoading, setIsLoading] = useState<boolean>(false);

  const registerTrackingDetail = async (
    req: RequestRegisterTrackingDetailRequest
  ): Promise<{ ok: boolean; notConnected: boolean; notifyFailed: boolean }> => {
    setIsLoading(true);
    setError(null);

    try {
      setIsLoading(true);
      const config = createConfiguration();
      const request: AmazonRegisterTrackingDetailPostRequest = {
        req,
      };

      const api = new AmazonApi(config);
      const response = await api.amazonRegisterTrackingDetailPost(request);
      setResultRegister(response);
      // 実際のレスポンスは { result, notified }（生成クライアントの型は boolean のまま）
      // notified=false は「発送は完了したがセラーへのChatwork通知に失敗」
      const body = response as unknown as { notified?: boolean };
      return {
        ok: response,
        notConnected: false,
        notifyFailed: body?.notified === false,
      };
    } catch (err: any) {
      const notConnected = isLwaNotConnectedError(err);
      const message = notConnected
        ? "LWA_NOT_CONNECTED"
        : err?.response?.data?.error ?? "発送処理に失敗しました";
      setError(message);
      return { ok: false, notConnected, notifyFailed: false };
    } finally {
      setIsLoading(false);
    }
  };

  return { registerTrackingDetail, resultRegister, error, setError, isLoading };
};
